import Cookies from 'js-cookie';

interface AlertBannerProps {
    el: HTMLElement;
}

const AlertBanner = ({ el }: AlertBannerProps): void => {
    const { cookieName } = el.dataset.alertBanner ? JSON.parse(el.dataset.alertBanner) : undefined;
    const closeIcon = el.querySelector('.alert-banner-close-button');
    const cookie = cookieName ? Cookies.get(cookieName) : undefined;

    if (!cookie) {
        el.classList.remove('hide');
    }

    closeIcon?.addEventListener('click', () => {
        el.classList.add('hide');

        if (cookieName) {
            Cookies.set(cookieName, '1', { expires: 30 });
        }
    });
};

export default AlertBanner;
